export default [{
        path: '/original',
        name: 'original',
        component: resolve => require(['../../view/original/original.vue'], resolve),
        redirect: '/hot',
        meta: { navShow: true },
        children: [{
                path: '/hot',
                component: (resolve) => require(['../../view/original/hot.vue'], resolve),
                meta: { 
                    navShow: true,
                    keepAlive: true // 需要缓存
                 },
            },
            {
                path: '/focusOn',
                component: (resolve) => require(['../../view/original/focusOn.vue'], resolve),
                meta: { 
                    navShow: true,
                    keepAlive: true // 需要缓存
                 },
            },
            {
                path: '/latest',
                component: (resolve) => require(['../../view/original/latest.vue'], resolve),
                meta: { 
                    navShow: true,
                    keepAlive: true // 需要缓存
                 },
            }
        ]
    },
    {
        path: '/videoPaly',
        name: 'videoPaly',
        component: (resolve) => require(['../../view/original/common/videoPaly.vue'], resolve)
    },
    {
        path: '/release',
        name: 'release',
        component: (resolve) => require(['../../view/original/release.vue'], resolve)
    },
    {
        path: '/information',
        name: 'information',
        component: (resolve) => require(['../../view/original/information.vue'], resolve),
    },
    {
        path: '/messageDetails',
        name: 'messageDetails',
        component: (resolve) => require(['../../view/original/notice/messageDetails.vue'], resolve)
    },
    {
        path: '/messageShow',
        name: 'messageShow',
        component: (resolve) => require(['../../view/original/notice/messageShow.vue'], resolve)
    },
]


// WEBPACK FOOTER //
// ./src/router/original/index.js